import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { RootState } from "../../utils/store";
import { inquireNPS, InquireNPSResponse, setOverallNPS } from "./nps.api";
import { InquireNPSErrors, SetOverallNPSErrors } from "./nps.error";

export const inquireNPSThunk = createAsyncThunk(
  "NPS/inquireNPS",
  async (request: void, { rejectWithValue, dispatch }) => {
    const { response, error } = await inquireNPS();
    if (error) {
      toast.info(InquireNPSErrors[error]);
      return rejectWithValue(error);
    }
    return response;
  }
);

export const setOverallNPSThunk = createAsyncThunk(
  "NPS/setOverallNPS",
  async (request: void, { rejectWithValue, dispatch, getState }) => {
    const state = getState() as RootState;
    const { error } = await setOverallNPS({
      audience_group_id: state.NPS.audience_group_id || 0,
    });
    if (error) {
      toast.info(SetOverallNPSErrors[error]);
      return rejectWithValue(error);
    }

    return;
  }
);
